<template>
  <h1 class="fs-2 mt-2 text-center">{{ chart_type === "opportunity" ? "Opportunity" : "Risk" }} assessment</h1>
  <div class="chart-container1 w-100 rounded-2 m-0 overflow-hidden" :id="chartId"></div>
</template>

<script>
/* eslint-disable */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import globalVar from "@/assets/globalVar.json"


export default {
  data() {
    return {
      data: [
        {
          category: "Value",
          id: "value",
          full: 5,
          direction: "",
          columnSettings: {
            fill: "chart.get('colors').getIndex(3)"
          }
        },
      ],
      selectedCountry: null,
      status: {
        text: '',
        color: ''
      }
    };
  },
  props: {
    data_country: {
      type: Object,
      required: true,
    },
    chart_type: {
      type: String,
      required: true
    },
    chartId:{
      type: String,
      required: true
    }
  },
  methods: {

    getColor(value) {
      let rangesData = [];
      if (this.chart_type === "opportunity"){
        rangesData = globalVar.opport
      } else {
        rangesData = globalVar.risk
      }

      let category = '';
      if (value >= 5) {
        category = rangesData[4].color;
      } else {
        category = '#808080'
        for (let i = 0; i < rangesData.length; i++) {
          if(value >= rangesData[i].rangeMin - 0.005 && value <= rangesData[i].rangeMax - 0.005){
            category = rangesData[i].color;
            break;
          }
        }
      }

      return category;
    },

    createChart(){
      am4core.useTheme(am4themes_animated);

      let chart = am4core.create(this.chartId, am4charts.GaugeChart);
      chart.hiddenState.properties.opacity = 0;

      chart.innerRadius = -50;


      let axis = chart.xAxes.push(new am4charts.ValueAxis());
      axis.min = 1;
      axis.max = 5;
      axis.strictMinMax = true;
      axis.renderer.grid.template.stroke = new am4core.InterfaceColorSet().getFor("background");
      axis.renderer.grid.template.strokeOpacity = 0.3;

      axis.renderer.labels.template.location = 0.5; 
      axis.renderer.minGridDistance = 100; 
      axis.strictMinMax = true;

      
      var label = chart.radarContainer.createChild(am4core.Label);
      label.isMeasured = false;
      label.fontSize = 30;
      label.x = am4core.percent(50);
      label.y = am4core.percent(100);
      label.horizontalCenter = "middle";
      label.verticalCenter = "bottom";
      label.text
      

      let rangeArray = []
      let rangesData = []

      if(this.chart_type == 'risk'){
        rangesData = globalVar.risk

        if(this.data_country.risk.value == null){
          this.status.text = "No Risk Indicator available"
        }

        if (this.data_country.risk.value >= 5) {
            this.status.text = rangesData[4].indicator
            this.status.color = "color: "+rangesData[4].color
        } else {
          for (let i = 0; i < rangesData.length; i++) {
            if(this.data_country.risk.value >= rangesData[i].rangeMin - 0.005 && this.data_country.risk.value <= rangesData[i].rangeMax - 0.005){
              this.status.text = rangesData[i].indicator
              this.status.color = "color: "+rangesData[i].color
              break;
            }
          }
        }

        this.data[0].value = Math.round(this.data_country.risk.value * 100)/100
        label.text = Math.round(this.data_country.risk.value * 100)/100
        label.fill = am4core.color(this.getColor( this.data[0].value))
      } else if(this.chart_type == 'opportunity'){
        rangesData = globalVar.opport

        if(this.data_country.opportunity.value == null){
          this.status.text = "No Opportunity Indicator available"
        }

        if (this.data_country.opportunity.value >= 5) {
            this.status.text = rangesData[4].indicator
            this.status.color = "color: "+rangesData[4].color
        } else {
          for (let i = 0; i < rangesData.length; i++) {
            if(this.data_country.opportunity.value >= rangesData[i].rangeMin - 0.005 && this.data_country.opportunity.value <= rangesData[i].rangeMax - 0.005){
              this.status.text = rangesData[i].indicator
              this.status.color = "color: "+rangesData[i].color
              break;
            }
          }
        }



        this.data[0].value = Math.round(this.data_country.opportunity.value * 100)/100
        if(this.data[0].value != 0){
          label.text = Math.round(this.data_country.opportunity.value * 100)/100
          label.fill = am4core.color(this.getColor( this.data[0].value))
        }
        
      } else {
        throw new Error("Incorrect or absent chart type")
      }


      for(let i = 0; i < rangesData.length; i++){
        rangeArray.push(axis.axisRanges.create())
        rangeArray[i].value = rangesData[i].rangeMin
        rangeArray[i].endValue = rangesData[i].rangeMax
        rangeArray[i].axisFill.fillOpacity = 1;
        
        const fillColor = this.data[0].value === 0
          ? "#999999"
          : rangesData[i].color;

        rangeArray[i].axisFill.fill = fillColor
        rangeArray[i].axisFill.zIndex = - 1;
      }

      
      if(this.data[0].value != 0){
        var hand = chart.hands.push(new am4charts.ClockHand());
        hand.innerRadius=am4core.percent(30)
        hand.radius= am4core.percent(70)
        hand.pin.disabled = true;
        chart.events.on("ready", ()=>{
          hand.showValue(this.data[0].value, 1000, am4core.ease.cubicOut);
        });  
      }
      
      let title = chart.titles.create();
      let lastUpdate = "Last Update"
      let arrowStyle = ""
      console.log("this.chart_type",this.chart_type)
      if(this.chart_type == 'risk'){
        if(this.data[0].direction == 'increase'){
          arrowStyle =  `<div style=\"text-align: center; font-size: 20px;\" title=\"${lastUpdate}\"><span>Trend since Last Update&nbsp;</span><span style=\"color: red;\">🡅</span></div>`
         
        } else if (this.data[0].direction == 'decrease') {
          arrowStyle = `<div style=\"text-align: center; font-size: 20px;\" title=\"${lastUpdate}\"><span>Trend since Last Update&nbsp;</span><span style=\"color: green;\">🡇</span></div>`
        } else {
          arrowStyle = `<div style=\"text-align: center; font-size: 20px;\" title=\"${lastUpdate}\"><span>Trend since Last Update&nbsp;</span><span style=\"color: grey;\">⚊</span></div>`
        }
        // title.html = "Risk assessment" + arrowStyle;
        title.html = `<div class=\"fs-2 mt-2 text-center\" style=\"${this.status.color};\">${this.status.text}</div>` + arrowStyle; 
      } else {
        console.log("this.data2",this.data)
        console.log("this.data2[0]",this.data[0])
        if(this.data[0].direction == 'increase'){
          arrowStyle = `<div style=\"text-align: center; font-size: 20px;\"><span>Trend since ${lastUpdate}  </span><span style=\"color: green;\">🡅</span></div>`
          // arrowStyle = `<div style=\"text-align: center; font-size: 20px;\" title=\"${lastUpdate}\"><span>Trend since Last Update&nbsp;</span><span style=\"color: grey;\">⚊</span></div>`
        } else if (this.data[0].direction == 'decrease'){
          arrowStyle = `<div style=\"text-align: center; font-size: 20px;\"><span>Trend since ${lastUpdate}  </span><span style=\"color: red;\">🡇</span></div>`
          // arrowStyle = `<div style=\"text-align: center; font-size: 20px;\" title=\"${lastUpdate}\"><span>Trend since Last Update&nbsp;</span><span style=\"color: grey;\">⚊</span></div>`
        } else {
          arrowStyle = `<div style=\"text-align: center; font-size: 20px;\" title=\"${lastUpdate}\"><span>Trend since Last Update&nbsp;</span><span style=\"color: grey;\">⚊</span></div>`
        }
        // title.html = "Opportunity assessment" + arrowStyle;
        title.html = `<div class=\"fs-2 mt-2 text-center\" style=\"${this.status.color};\">${this.status.text}</div>` + arrowStyle; 
      }
      title.fontSize = 25;
      title.marginBottom = 30;
      chart.events.on("ready", () => {
        let annotation = chart.chartContainer.createChild(am4core.Container);
        annotation.layout = "horizontal";
        annotation.align = "left";
        annotation.valign = "bottom";
        annotation.marginTop = 5;
        annotation.padding(0, 0, 0, 0);

        let label1 = annotation.createChild(am4core.Label);
        if(this.chart_type == 'risk'){
          label1.html = `<span style="color: red; font-size: 14px;">🡅</span> <span style="font-size: 11px; color: #444;">higher risk since last update</span>`;
        } else {
          // label1.html = `<span style="color: grey; font-size: 14px;">⚊</span> <span style="font-size: 11px; color: #444;">No comparison possible</span>`;
          label1.html = `<span style="color: green; font-size: 14px;">🡅</span> <span style="font-size: 11px; color: #444;">higher opportunity since last update</span>`;  
        }
        label1.marginRight = 10;

        let label2 = annotation.createChild(am4core.Label);
        if(this.chart_type == 'risk'){
          label2.html = `<span style="color: green; font-size: 14px;">🡇</span> <span style="font-size: 11px; color: #444;">lower risk since last update</span>`;
        } else {
          label2.html = `<span style="color: red; font-size: 14px;">🡇</span> <span style="font-size: 11px; color: #444;">lower opportunity since last update</span>`;
          // label2.html = `<span style="color: red; font-size: 14px;"></span>`;
        }
      })
    }

    
  },
  mounted() {
        // created() {
      if (this.chart_type == 'risk') {
        this.data[0].direction = this.data_country.risk.evo
      } else {
        this.data[0].direction = this.data_country.opportunity.evo
      }
    // },
    this.createChart();
    console.log("this.data_country",this.data_country)
    console.log("this.data",this.data[0])
  },
  beforeUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
};
</script>
